import React from 'react';
import { Box, Heading, VStack, HStack, Text, Badge, IconButton, Tooltip } from '@chakra-ui/react';
import { FaSearchLocation } from 'react-icons/fa';

const OrigemTag = ({ origem, conta }) => {
    if (origem === 'ml') {
        return (
            <Badge
                colorScheme={String(conta) === '2' ? 'blue' : String(conta) === '3' ? 'green' : 'yellow'}
                fontSize="9px" px={1.5} borderRadius="md" variant="solid"
                flexShrink={0}
            >
                ML {conta ?? ''}
            </Badge>
        );
    }
    return (
        <Badge colorScheme="purple" fontSize="9px" px={1.5} borderRadius="md" variant="solid" flexShrink={0}>
            {String(origem || '').toUpperCase()}
        </Badge>
    );
};

const UrgentRow = ({ dev, onLocate }) => {
    const origem = (dev.origem || 'ml').toLowerCase();
    const item = Array.isArray(dev.orders) ? (dev.orders[0] || {}) : {};
    const orderId = item.order_id || dev.id_order_ml;
    const idOrigem = dev.id_origem || orderId;
    const headerId = idOrigem || dev.id_venda;
    const produto = item.nome || 'Produto não identificado';
    const finalizada = Number(dev.finalizada) === 1;

    return (
        <HStack
            spacing={3}
            px={3}
            py={2}
            bg={finalizada ? 'gray.50' : 'white'}
            borderRadius="md"
            borderWidth="1px"
            borderColor={finalizada ? 'gray.300' : 'red.200'}
            align="center"
            opacity={finalizada ? 0.75 : 1}
        >
            <OrigemTag origem={origem} conta={dev.conta} />
            <Text
                fontSize="xs" fontWeight="bold"
                color={finalizada ? 'gray.500' : 'gray.700'}
                fontFamily="mono" flexShrink={0}
                textDecoration={finalizada ? 'line-through' : 'none'}
            >
                #{headerId}
            </Text>
            <Text
                fontSize="xs"
                color={finalizada ? 'gray.500' : 'gray.800'}
                noOfLines={1} flex={1} title={produto}
                textDecoration={finalizada ? 'line-through' : 'none'}
            >
                {produto}
            </Text>
            {finalizada && (
                <Badge colorScheme="green" fontSize="9px" px={1.5} borderRadius="md" variant="solid" flexShrink={0}>
                    FINALIZADA
                </Badge>
            )}
            {onLocate && (
                <Tooltip label="Localizar no kanban" hasArrow>
                    <IconButton
                        aria-label="Localizar no kanban"
                        icon={<FaSearchLocation />}
                        size="xs"
                        variant="ghost"
                        colorScheme={finalizada ? 'gray' : 'red'}
                        onClick={() => onLocate(dev)}
                    />
                </Tooltip>
            )}
        </HStack>
    );
};

const DevolucoesUrgentBanner = ({ urgentList, onLocate }) => {
    if (!urgentList || urgentList.length === 0) return null;

    const pendentes  = urgentList.filter(d => Number(d.finalizada) !== 1);
    const finalizadas = urgentList.filter(d => Number(d.finalizada) === 1);
    // pendentes primeiro, depois finalizadas
    const ordenada = [...pendentes, ...finalizadas];

    return (
        <Box
            mb={6}
            border="2px dashed"
            borderColor="red.400"
            borderRadius="lg"
            p={{ base: 2, md: 4 }}
            bg="red.50"
        >
            <Heading size="md" color="red.700" mb={1} textAlign="center">
                ÚLTIMO DIA DE REVISÃO ({urgentList.length})
            </Heading>
            {finalizadas.length > 0 && (
                <Text fontSize="xs" color="gray.600" textAlign="center" mb={3}>
                    <Text as="span" fontWeight="bold" color="red.600">{pendentes.length} pendente{pendentes.length !== 1 ? 's' : ''}</Text>
                    {' · '}
                    <Text as="span" color="gray.500">{finalizadas.length} finalizada{finalizadas.length !== 1 ? 's' : ''}</Text>
                </Text>
            )}
            <VStack spacing={2} align="stretch">
                {ordenada.map((dev) => (
                    <UrgentRow key={dev.id} dev={dev} onLocate={onLocate} />
                ))}
            </VStack>
        </Box>
    );
};

export default DevolucoesUrgentBanner;
